import React, { useEffect, useState } from "react";
import Sidebar from "../composant_reutilisable/sidebar";
import Navbar from "../composant_reutilisable/navbar";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../composant_reutilisable/useAuth";
import {
  FaHome, FaTruck, FaBoxes,
  FaCalendarAlt, FaFilter, FaChartBar,
  FaDownload,
  FaRedoAlt,
  FaSearch,
  FaArrowRight,
  FaQuestionCircle,
  FaTimes,
  FaChevronDown
} from "react-icons/fa";
import axios from "axios";
import { debounce } from "lodash";
import Select from 'react-select';
import { FaSortAmountUp, FaSortAmountDown } from "react-icons/fa";
import { Modal, Button, Form, Spinner, Row, Col } from "react-bootstrap";
import GlossaireSidebar from '../composant_reutilisable/glossaireSidebar';
import Pas_acces from "../composant_reutilisable/pas_acces";

const Rapport_et_statistique = () => {
  useAuth();
  const user_id = localStorage.getItem('userId');
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    // Données agrégées par type
    entrees: null,
    sorties: null,
    lettre_dispo: null,
    fret: null,
    fret_termine: null,
    organisation: null,
    factures: null,

    // Listes complètes
    entreesListe: null,
    sortiesListe: null,
    lettre_dispoListe: null,
    fretListe: null,
    fret_termineListe: null,
    organisationListe: null,
    facturesListe: null,

    loading: true,
    error: null,
  });

  // États pour les données de référence
  const [parcs, setParcs] = useState([]);
  const [typesVehicule, setTypesVehicule] = useState([]);
  const [categories, setCategories] = useState([]);
  const [organisations, setOrganisations] = useState([]);
  const [typesFret, setTypesFret] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('tab-1');
  const [showRechercheModal, setShowRechercheModal] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);

  // Fonction de tri
  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  // Fonction pour trier les données
  const sortedData = (data) => {
    if (!data) return [];
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  };

  // Fonction de recherche
  const filteredData = (data) => {
    if (!data) return [];
    if (!searchTerm) return data;

    return data.filter(item => {
      return Object.values(item).some(
        val => val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
  };

  // États pour les filtres
  const [filters, setFilters] = useState({
    type_stat: 'entrees',
    periode: 'Tout',
    type_parc: [],
    droit_tour: [],
    parc_id: [],
    type_vehicule_id: [],
    categorie_id: [],
    organisation_ids: [],
    type_fret_refs: [],
    date_debut: '',
    date_fin: ''
  });

  // Chargement des données de référence
  useEffect(() => {
    const fetchReferenceData = async () => {
      try {
        // Charger les parcs
        const parcsResponse = await axios.get(process.env.REACT_APP_HOTE + "/liste-parc/");
        setParcs(parcsResponse.data);

        // Charger les types de véhicule
        const typesResponse = await axios.get(process.env.REACT_APP_HOTE + "/liste-types/");
        setTypesVehicule(typesResponse.data);

        // Charger les catégories
        const listeCategorie = await axios.get(process.env.REACT_APP_HOTE + "/liste-categories/");
        setCategories(listeCategorie.data);

        // // Charger les organisations professionnelles
        // const orgResponse = await axios.get(process.env.REACT_APP_HOTE + "/liste-organisations/");
        // setOrganisations(orgResponse.data);

        // // Charger les types de fret
        // const typesFretResponse = await axios.get(process.env.REACT_APP_HOTE + "/liste-types-fret/");
        // setTypesFret(typesFretResponse.data);

      } catch (error) {
        console.error("Erreur lors du chargement des données de référence:", error);
      }
    };

    fetchReferenceData();
  }, []);

  // Gestion des changements d'onglet
  useEffect(() => {
    if (user_id) {
      document.title = "Transportpro | Rapport et statistiques";

      // Mettre à jour le type_stat en fonction de l'onglet actif
      let newTypeStat;
      switch (activeTab) {
        case 'tab-1': newTypeStat = 'entrees'; break;
        case 'tab-2': newTypeStat = 'sorties'; break;
        case 'tab-3': newTypeStat = 'lettre_dispo'; break;
        case 'tab-4': newTypeStat = 'fret'; break;
        case 'tab-5': newTypeStat = 'fret_termine'; break;
        case 'tab-6': newTypeStat = 'organisation'; break;
        case 'tab-7': newTypeStat = 'factures'; break;
        default: newTypeStat = 'entrees';
      }

      setFilters(prev => ({ ...prev, type_stat: newTypeStat }));
    }
  }, [user_id, activeTab]);

  // Charger les statistiques quand le type_stat change
  useEffect(() => {
    if (filters.type_stat) {
      fetchStats();
    }
  }, [filters.type_stat]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
      ...(name === "type_parc" && { parc_id: [] })
    }));
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
      periode: 'custom'
    }));
  };

  const handleMultiSelectChange = (name) => (selected) => {
    setFilters(prev => ({
      ...prev,
      [name]: selected ? selected.map(opt => opt.value) : []
    }));
  };

  const fetchStats = async () => {
    try {
      setStats(prev => ({ ...prev, loading: true, error: null }));
      setHasSearched(true);

      // Vérification des dates pour la période custom
      if (filters.periode === 'custom') {
        if (!filters.date_debut || !filters.date_fin) {
          setStats(prev => ({
            ...prev,
            loading: false,
            error: "Veuillez sélectionner les deux dates pour une période personnalisée"
          }));
          return;
        }

        if (new Date(filters.date_fin) < new Date(filters.date_debut)) {
          setStats(prev => ({
            ...prev,
            loading: false,
            error: "La date de fin doit être postérieure à la date de début"
          }));
          return;
        }
      }

      // Préparer les filtres appliqués pour l'affichage
      const newAppliedFilters = prepareAppliedFilters();
      setAppliedFilters(newAppliedFilters);

      // Préparer les paramètres pour l'API
      const params = prepareApiParams();

      console.log('📤 Paramètres envoyés:', params);

      // Appel API
      const response = await axios.get(process.env.REACT_APP_HOTE + "/statistiques-transport/", {
        params: params
      });

      console.log('📥 Réponse API:', response.data);

      if (response.data.success) {
        // Traitement des données selon le type_stat
        const typeStat = filters.type_stat;
        const resultatsAgreges = response.data.resultats_agreges || {};
        const elementsComplets = response.data.elements_complets || [];

        // Mise à jour du state avec les données structurées
        setStats(prev => ({
          ...prev,
          // Mettre à jour les données agrégées
          [typeStat]: resultatsAgreges,
          [`${typeStat}Liste`]: elementsComplets,
          loading: false,
          error: null
        }));
      } else {
        setStats(prev => ({
          ...prev,
          loading: false,
          error: response.data.error || "Erreur lors du chargement des statistiques"
        }));
      }

    } catch (error) {
      console.error("Erreur:", error);
      setStats(prev => ({
        ...prev,
        loading: false,
        error: "Erreur lors du chargement des statistiques"
      }));
    } finally {
      handleCloseRechercheModal();
    }
  };

  const prepareAppliedFilters = () => {
    const newAppliedFilters = [];

    // Filtre type_parc
    if (filters.type_parc) {
      const typeParcLabel = filters.type_parc === 'national' ? 'National' : 'International';
      newAppliedFilters.push({
        label: `Type parc: ${typeParcLabel}`,
        key: 'type_parc'
      });
    }

    // Filtre parc_id
    if (filters.parc_id && filters.parc_id.length > 0) {
      const parcLabels = filters.parc_id.map(id => {
        const parc = parcs.find(p => p.ref_parc === id);
        return parc ? parc.nom_parc : id;
      });
      newAppliedFilters.push({
        label: `Parc: ${parcLabels.join(', ')}`,
        key: 'parc_id'
      });
    }

    // Filtre droit_tour
    if (filters.droit_tour) {
      newAppliedFilters.push({
        label: `Droit de tour: ${filters.droit_tour === 'Oui' ? 'Oui' : 'Non'}`,
        key: 'droit_tour'
      });
    }

    // Filtre type_vehicule_id
    if (filters.type_vehicule_id && filters.type_vehicule_id.length > 0) {
      const typeVehiculeLabels = filters.type_vehicule_id.map(id => {
        const type = typesVehicule.find(t => t.id === id);
        return type ? type.libelle : id;
      });
      newAppliedFilters.push({
        label: `Type véhicule: ${typeVehiculeLabels.join(', ')}`,
        key: 'type_vehicule_id'
      });
    }

    // Filtre categorie_id
    if (filters.categorie_id && filters.categorie_id.length > 0) {
      const categorieLabels = filters.categorie_id.map(id => {
        const categorie = categories.find(c => c.ref_categorie === id);
        return categorie ? categorie.nom_categorie : id;
      });
      newAppliedFilters.push({
        label: `Catégorie: ${categorieLabels.join(', ')}`,
        key: 'categorie_id'
      });
    }

    // Filtre organisation_ids
    if (filters.organisation_ids && filters.organisation_ids.length > 0) {
      const orgLabels = filters.organisation_ids.map(id => {
        const org = organisations.find(o => o.id === id);
        return org ? org.libelle : id;
      });
      newAppliedFilters.push({
        label: `Organisation: ${orgLabels.join(', ')}`,
        key: 'organisation_ids'
      });
    }

    // Filtre période
    if (filters.periode && filters.periode !== 'Tout') {
      const periodeLabels = {
        jour: 'Jour',
        semaine: 'Semaine',
        mois: 'Mois',
        trimestre: 'Trimestre',
        annee: 'Année',
        custom: 'Personnalisée'
      };

      newAppliedFilters.push({
        label: `Période: ${periodeLabels[filters.periode] || filters.periode}`,
        key: 'periode'
      });

      if (filters.periode === 'custom' && filters.date_debut && filters.date_fin) {
        newAppliedFilters.push({
          label: `Du ${filters.date_debut} au ${filters.date_fin}`,
          key: 'date_range'
        });
      }
    }

    return newAppliedFilters;
  };

  const prepareApiParams = () => {
    const params = {
      type_stat: filters.type_stat,
      periode: filters.periode,
    };

    // Ajouter les filtres conditionnels
    if (filters.type_parc && filters.type_parc.length > 0) {
      params.type_parc = Array.isArray(filters.type_parc) ? filters.type_parc.join(',') : filters.type_parc;
    }

    if (filters.droit_tour && filters.droit_tour.length > 0) {
      params.droit_tour = Array.isArray(filters.droit_tour) ? filters.droit_tour.join(',') : filters.droit_tour;
    }

    if (filters.parc_id && filters.parc_id.length > 0) {
      params.parc = Array.isArray(filters.parc_id) ? filters.parc_id.join(',') : filters.parc_id;
    }

    if (filters.type_vehicule_id && filters.type_vehicule_id.length > 0) {
      params.type_vehicule = Array.isArray(filters.type_vehicule_id) ? filters.type_vehicule_id.join(',') : filters.type_vehicule_id;
    }

    if (filters.categorie_id && filters.categorie_id.length > 0) {
      params.categorie_id = Array.isArray(filters.categorie_id) ? filters.categorie_id.join(',') : filters.categorie_id;
    }

    if (filters.organisation_ids && filters.organisation_ids.length > 0) {
      params.organisation_ids = Array.isArray(filters.organisation_ids) ? filters.organisation_ids.join(',') : filters.organisation_ids;
    }

    if (filters.type_fret_refs && filters.type_fret_refs.length > 0) {
      params.type_fret_refs = Array.isArray(filters.type_fret_refs) ? filters.type_fret_refs.join(',') : filters.type_fret_refs;
    }

    if (filters.periode === 'custom') {
      params.date_debut = filters.date_debut;
      params.date_fin = filters.date_fin;
    }

    return params;
  };

  const [isloadingTelechargement, setIsloadingTelechargement] = useState(false);
  const telechargerRapport = async () => {
    try {
      setIsloadingTelechargement(true);

      // Préparation des paramètres
      const params = prepareApiParams();

      const response = await axios({
        url: process.env.REACT_APP_HOTE + `/export-statistiques-pdf/${user_id}/`,
        method: 'GET',
        params: params,
        responseType: 'blob',
      });

      // Création du lien de téléchargement
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // Extraction du nom de fichier depuis les headers
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'statistiques.pdf';

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Nettoyage
      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Erreur lors du téléchargement:", error);
    } finally {
      setIsloadingTelechargement(false);
    }
  };

  const formatNumber = (num) => {
    if (!num) return '0';
    return new Intl.NumberFormat('fr-FR').format(num);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    const formattedDate = date.toLocaleDateString("fr-FR", optionsDate);
    const formattedTime = date.toLocaleTimeString("fr-FR", optionsTime);
    return `${formattedDate} ${formattedTime}`;
  };

  // Options pour les select
  const parcOptions = parcs.map(parc => ({
    value: parc.ref_parc,
    label: parc.nom_parc
  }));

  const typeVehiculeOptions = typesVehicule.map(type => ({
    value: type.id,
    label: type.libelle
  }));

  const categorieOptions = categories.map(categorie => ({
    value: categorie.ref_categorie,
    label: categorie.nom_categorie
  }));

  const organisationOptions = organisations.map(org => ({
    value: org.id,
    label: org.libelle
  }));

  const typeFretOptions = typesFret.map(type => ({
    value: type.ref,
    label: type.libelle
  }));

  // Labels des colonnes pour chaque type de statistique
  const columnLabels = {
    entrees: {
      date_creation: "Date d'entrée",
      camion: "Camion",
      type_camion: "Type véhicule",
      proprietaire: "Propriétaire",
      // proprietaire_tete: "Propriétaire tete",
      // proprietaire_queue: "Propriétaire queue",
      // proprietaire_non_articule: "Propriétaire non articulé",
      charge_utile: "Charge utile",
      parc: "Parc",
      // droit_tour: "Droit de tour",
      // statut: "Statut"
    },
    sorties: {
      date_creation: "Date d'entrée",
      date_sortie_reele: "Date de sortie",
      camion: "Camion",
      type_camion: "Type véhicule",
      proprietaire: "Propriétaire",
      // proprietaire_tete: "Propriétaire tete",
      // proprietaire_queue: "Propriétaire queue",
      // proprietaire_non_articule: "Propriétaire non articulé",
      charge_utile: "Charge utile",
      parc: "Parc",
      // droit_tour: "Droit de tour",
      // statut: "Statut"
    },
    lettre_dispo: {
      date_creation: "Date création",
      immatriculation: "Immatriculation",
      type_camion: "Type véhicule",
      proprietaire: "Propriétaire",
      // proprietaire_tete: "Propriétaire tete",
      // proprietaire_queue: "Propriétaire queue",
      proprietaire_non_articule: "Propriétaire",
      charge_utile: "Charge utile",
      parc: "Parc",
      // statut: "Statut"
    },
    fret: {
      date_creation: "Date création",
      ref: "Référence",
      type_fret: "Type de fret",
      bailleur: "Bailleur",
      nom_destinataire: "Destinataire",
      ville_depart: "Ville départ",
      ville_arrivee: "Ville arrivée",
      pays_depart: "Pays départ",
      pays_arrivee: "Pays arrivée",
      charge_utile_totale: "Charge totale",
      parc_ref: "Parc",
      categorie: "Catégorie",
      nb_lots: "Nombre de lots",
      // statut: "Statut"
    },
    fret_termine: {
      date_creation: "Date création",
      ref: "Référence",
      type_fret: "Type de fret",
      bailleur: "Bailleur",
      nom_destinataire: "Destinataire",
      ville_depart: "Ville départ",
      ville_arrivee: "Ville arrivée",
      pays_depart: "Pays départ",
      pays_arrivee: "Pays arrivée",
      charge_utile_totale: "Charge totale",
      parc_ref: "Parc",
      categorie: "Catégorie",
      nb_lots: "Nombre de lots",
      // statut: "Statut"
    },
    organisation: {
      nom: "Nom",
      prenoms: "Prénoms",
      organisation_professionnelle__libelle: "Organisation",
      nombre_tours: "Nombre de tours"
    },
    factures: {
      reference_lv: "Référence LV",
      montant_total: "Montant total",
      // statut: "Statut",
      date_creation: "Date création",
      parc: "Parc",
      tour_associe: "Tour associé",
      proprietaires: "Propriétaires",
      nombre_lignes: "Nbre lignes"
    }
  };

  // État pour la visibilité des colonnes
  const [visibleColumns, setVisibleColumns] = useState({
    entrees: {
      date_creation: true,
      camion: true,
      type_camion: true,
      proprietaire: true,
      // proprietaire_tete: false,
      // proprietaire_queue: false,
      // proprietaire_non_articule: false,
      charge_utile: true,
      parc: true,
      droit_tour: true,
      statut: false
    },
    sorties: {
      date_creation: false,
      date_sortie_reele: true,
      camion: true,
      type_camion: true,
      proprietaire: true,
      // proprietaire_tete: false,
      // proprietaire_queue: false,
      // proprietaire_non_articule: false,
      charge_utile: true,
      parc: true,
      droit_tour: true,
      statut: false
    },
    lettre_dispo: {
      date_creation: true,
      immatriculation: true,
      type_camion: true,
      proprietaire: true,
      // proprietaire_tete: false,
      // proprietaire_queue: false,
      // proprietaire_non_articule: true,
      charge_utile: true,
      parc: true,
      statut: true
    },
    fret: {
      date_creation: true,
      ref: true,
      type_fret: true,
      bailleur: false,
      nom_destinataire: false,
      ville_depart: true,
      ville_arrivee: true,
      pays_depart: false,
      pays_arrivee: false,
      nb_lots: true,
      parc_ref: false,
      categorie: false,
    },
    fret_termine: {
      date_creation: true,
      ref: true,
      type_fret: true,
      bailleur: false,
      nom_destinataire: false,
      ville_depart: true,
      ville_arrivee: true,
      pays_depart: false,
      pays_arrivee: false,
      nb_lots: true,
      parc_ref: false,
      categorie: false,
    },
    organisation: {
      nom: true,
      prenoms: true,
      organisation_professionnelle__libelle: true,
      nombre_tours: true
    },
    factures: {
      reference_lv: true,
      montant_total: true,
      statut: true,
      date_creation: true,
      parc: true,
      tour_associe: true,
      proprietaires: false,
      nombre_lignes: true
    }
  });

  const ColumnSelector = ({ type, visibleColumns, setVisibleColumns, columnLabels }) => {
    const [showColumnSelector, setShowColumnSelector] = useState(false);

    return (
      <div className="column-selector position-relative">
        <button
          style={{
            width: "auto",
            border: "1px solid #000",
            borderRadius: "5px",
            backgroundColor: "transparent",
            padding: "5px 10px",
            display: "flex",
            alignItems: "center",
          }}
          className="text-dark"
          onClick={() => setShowColumnSelector((prev) => !prev)}
        >
          Visibilité
          <FaChevronDown className="ms-2" size={12} />
        </button>

        {showColumnSelector && (
          <div
            className="column-options bg-white p-3"
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              minWidth: "250px",
              border: "1px solid #ddd",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "4px",
              zIndex: 1000,
              marginTop: "5px",
              maxHeight: "200px",
              overflowY: "auto",
              scrollbarWidth: "thin",
              scrollbarColor: "#ddd #f8f9fa",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <strong>Sélection des colonnes</strong>
              <button
                className="btn btn-sm btn-link p-0"
                onClick={() => setShowColumnSelector(false)}
              >
                <FaTimes />
              </button>
            </div>

            <div className="overflow-auto">
              {Object.entries(columnLabels).map(
                ([columnKey, label]) => (
                  <div
                    key={columnKey}
                    className="form-check mb-2"
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`column-${type}-${columnKey}`}
                      checked={
                        visibleColumns[type]?.[columnKey] || false
                      }
                      onChange={() => {
                        setVisibleColumns(prev => ({
                          ...prev,
                          [type]: {
                            ...prev[type],
                            [columnKey]: !prev[type][columnKey]
                          }
                        }));
                      }}
                    />
                    <label
                      className="form-check-label ms-2"
                      htmlFor={`column-${type}-${columnKey}`}
                      style={{ cursor: "pointer" }}
                    >
                      {label}
                    </label>
                  </div>
                )
              )}
            </div>

            <div className="d-flex justify-content-between mt-2">
              <button
                className="btn btn-sm btn-outline-primary mr-2"
                onClick={() => {
                  setVisibleColumns(prev => ({
                    ...prev,
                    [type]: Object.keys(prev[type]).reduce(
                      (acc, key) => {
                        acc[key] = true;
                        return acc;
                      }, {})
                  }));
                }}
              >
                Tout sélectionner
              </button>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => {
                  setVisibleColumns(prev => ({
                    ...prev,
                    [type]: Object.keys(prev[type]).reduce(
                      (acc, key) => {
                        acc[key] = false;
                        return acc;
                      }, {})
                  }));
                }}
              >
                Tout désélectionner
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleShowRechercheModal = () => setShowRechercheModal(true);
  const handleCloseRechercheModal = () => setShowRechercheModal(false);

  const [hasSearched, setHasSearched] = useState(false);

  const AppliedFiltersDisplay = ({ filters, onRemoveFilter }) => {
    return (
      <div className="applied-filters mb-3">
        {filters.map((filter, index) => (
          <span key={index} className="badge badge-primary mr-2 mb-2">
            {filter.label}
            <button
              type="button"
              className="close ml-2"
              onClick={() => onRemoveFilter(filter.key)}
              style={{ fontSize: '1rem' }}
            >
              &times;
            </button>
          </span>
        ))}
      </div>
    );
  };

  const removeFilter = (filterKey) => {
    setFilters(prev => {
      const newFilters = { ...prev };

      switch (filterKey) {
        case 'type_parc':
          newFilters.type_parc = '';
          newFilters.parc_id = [];
          break;
        case 'parc_id':
          newFilters.parc_id = [];
          break;
        case 'droit_tour':
          newFilters.droit_tour = '';
          break;
        case 'type_vehicule_id':
          newFilters.type_vehicule_id = [];
          break;
        case 'categorie_id':
          newFilters.categorie_id = [];
          break;
        case 'organisation_ids':
          newFilters.organisation_ids = [];
          break;
        case 'periode':
          newFilters.periode = 'Tout';
          newFilters.date_debut = '';
          newFilters.date_fin = '';
          break;
        case 'date_range':
          newFilters.periode = 'Tout';
          newFilters.date_debut = '';
          newFilters.date_fin = '';
          break;
        default:
          break;
      }

      return newFilters;
    });

    // Mettre à jour les filtres appliqués
    setAppliedFilters(prev => prev.filter(f => f.key !== filterKey));

    // Relancer la recherche
    fetchStats();
  };

  const [showGlossary, setShowGlossary] = useState(false);

  const [accesGroupes, setAccesGroupes] = useState([]);
  const [groupeId, setGroupeId] = useState(null);
  const groupe = localStorage.getItem('groupe_id');

  const verifGroupe = async () => {
    const groupeStored = localStorage.getItem('groupe_id');
    const accesGroupeStored = localStorage.getItem('accesGroupe');

    if (groupeStored && accesGroupeStored) {
      setGroupeId(groupeStored);
      setAccesGroupes(JSON.parse(accesGroupeStored));
    } else {
      try {
        const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
        if (response.status === 200) {
          const data = response.data;
          setGroupeId(data.groupe);

          let cleanedAccessArray = [];
          if (Array.isArray(data.acces)) {
            cleanedAccessArray = data.acces.map((item) =>
              item.acces
                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                : []
            ).flat();

            setAccesGroupes(cleanedAccessArray);
          }

          localStorage.setItem('groupe', data.groupe);
          localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du groupe', error);
      }
    }
  };

  useEffect(() => {
    if (user_id) {
      verifGroupe();
    }
  }, [user_id]);

  // Rendu conditionnel basé sur les permissions
  if (!accesGroupes.includes("Rapport_et_statistique")) {
    return <Pas_acces />;
  }

  // Fonction pour afficher les statistiques agrégées
  const renderAggregatedStats = (typeStat) => {
    const aggregatedData = stats[typeStat];
    if (!aggregatedData) return null;

    return (
      <div className="mt-3 mb-4">
        <h5>Statistiques globales</h5>
        <div className="row">
          {/* Totaux généraux */}
          {aggregatedData.totaux_generaux && (
            <div className="col-md-4">
              <div className="card bg-light mb-3">
                <div className="card-body">
                  <h6 className="card-title">Totaux généraux</h6>
                  {Object.entries(aggregatedData.totaux_generaux).map(([key, value]) => (
                    <p key={key} className="mb-1">
                      {key.replace('_', ' ')}: <strong>{typeof value === 'number' ? formatNumber(value) : value}</strong>
                    </p>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Par type de véhicule */}
          {aggregatedData.par_type_vehicule && aggregatedData.par_type_vehicule.length > 0 && (
            <div className="col-md-4">
              <div className="card bg-light mb-3">
                <div className="card-body">
                  <h6 className="card-title">Par type de véhicule</h6>
                  {aggregatedData.par_type_vehicule.slice(0, 3).map((item, index) => (
                    <p key={index} className="mb-1">
                      {item.cle}: <strong>{item.nombre}</strong> ({item.pourcentage}%)
                    </p>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Par parc */}
          {aggregatedData.par_parc && aggregatedData.par_parc.length > 0 && (
            <div className="col-md-4">
              <div className="card bg-light mb-3">
                <div className="card-body">
                  <h6 className="card-title">Par parc</h6>
                  {aggregatedData.par_parc.slice(0, 3).map((item, index) => (
                    <p key={index} className="mb-1">
                      {item.cle}: <strong>{item.nombre}</strong>
                    </p>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Par catégorie (pour fret) */}
          {aggregatedData.par_categorie && aggregatedData.par_categorie.length > 0 && (
            <div className="col-md-4">
              <div className="card bg-light mb-3">
                <div className="card-body">
                  <h6 className="card-title">Par catégorie</h6>
                  {aggregatedData.par_categorie.slice(0, 3).map((item, index) => (
                    <p key={index} className="mb-1">
                      {item.cle}: <strong>{item.nombre}</strong>
                    </p>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Par organisation */}
          {aggregatedData.par_organisation && aggregatedData.par_organisation.length > 0 && (
            <div className="col-md-4">
              <div className="card bg-light mb-3">
                <div className="card-body">
                  <h6 className="card-title">Par organisation</h6>
                  {aggregatedData.par_organisation.slice(0, 3).map((item, index) => (
                    <p key={index} className="mb-1">
                      {item.cle}: <strong>{item.total_proprietaires}</strong> propriétaires ({item.total_tours} tours)
                    </p>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Top transporteurs */}
          {aggregatedData.top_transporteurs && aggregatedData.top_transporteurs.length > 0 && (
            <div className="col-md-4">
              <div className="card bg-light mb-3">
                <div className="card-body">
                  <h6 className="card-title">Top transporteurs</h6>
                  {aggregatedData.top_transporteurs.map((item, index) => (
                    <p key={index} className="mb-1">
                      {item.cle}: <strong>{item.nombre_tours}</strong> tours
                    </p>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Par statut (pour factures) */}
          {aggregatedData.par_statut && aggregatedData.par_statut.length > 0 && (
            <div className="col-md-4">
              <div className="card bg-light mb-3">
                <div className="card-body">
                  <h6 className="card-title">Par statut</h6>
                  {aggregatedData.par_statut.map((stat, index) => (
                    <p key={index} className="mb-1">
                      {stat.cle_display}: <strong>{stat.nombre}</strong> ({stat.pourcentage_nombre}%)
                    </p>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // Fonction pour déterminer quel type de données afficher
  const getCurrentData = () => {
    const typeMap = {
      'tab-1': 'entrees',
      'tab-2': 'sorties',
      'tab-3': 'lettre_dispo',
      'tab-4': 'fret',
      'tab-5': 'fret_termine',
      'tab-6': 'organisation',
      'tab-7': 'factures'
    };

    const currentType = typeMap[activeTab];
    return {
      type: currentType,
      aggregatedData: stats[currentType],
      completeData: stats[`${currentType}Liste`],
      columnLabels: columnLabels[currentType],
      visibleColumns: visibleColumns[currentType]
    };
  };

  // Composant générique pour afficher un tableau
  const GenericTable = ({ type, data, columnLabels, visibleColumns, showCounter = true }) => {
    if (!data || data.length === 0) {
      return <p className="text-center">Aucune donnée disponible</p>;
    }

    const currentData = getCurrentData();

    return (
      <>
        <div className="table-responsive">
          <div className="mt-3">
            <table className="table table-striped">
              <thead>
                <tr>
                  {Object.entries(columnLabels).map(([key, label]) => {
                    if (!visibleColumns[key]) return null;

                    return (
                      <th key={key} onClick={() => requestSort(key)}>
                        {label}
                        {sortConfig.key === key && (
                          sortConfig.direction === "descending"
                            ? <FaSortAmountUp className="ml-1" />
                            : <FaSortAmountDown className="ml-1" />
                        )}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {filteredData(sortedData(data)).map((item, index) => (
                  <tr key={index}>
                    {Object.entries(columnLabels).map(([key, label]) => {
                      if (!visibleColumns[key]) return null;

                      let value = item[key] ?? "";

                      // Formattage spécifique selon le type de donnée
                      if (key.includes("date") && value) {
                        value = formatDate(value);
                      } else if (key.includes("montant") && typeof value === 'string') {
                        value = formatNumber(parseFloat(value));
                      }

                      // Traitement spécial pour certaines colonnes
                      if (type === 'entrees' || type === 'sorties' || type === 'lettre_dispo') {
                        if (key === 'camion') {
                          value = item.atellage === '1'
                            ? `${item.tete} + ${item.queue}`
                            : item.immatriculation || '';
                        } else if (key === 'proprietaire'){
                          value = item.atellage === '1'
                            ? item.proprietaire_tete
                            : item.proprietaire_non_articule || '';
                        } else if (key === 'type_camion') {
                          // const typeVehicule = typesVehicule.find(t => t.id === item.type_camion);
                          value = item?.type_camion || '';
                        } else if (key === 'parc') {
                          const parc = parcs.find(p => p.ref_parc === item.parc);
                          value = parc?.nom_parc || '';
                        } else if (key === 'statut') {
                          const statutBadges = {
                            "Disponible": "badge-secondary text-black",
                            "Selectionne": "badge-success",
                            "Sorti": "badge-primary",
                            "Quitter": "badge-danger",
                            "En panne": "badge-warning"
                          };
                          const badgeClass = statutBadges[item.statut] || "badge-secondary";
                          value = (
                            <span className={`badge ${badgeClass}`}>
                              {item.statut === "Selectionne" ? "Chargement de marchandises" :
                                item.statut === "Sorti" ? "Transport de marchandises" :
                                  item.statut === "Quitter" ? "Sorti de rang" : item.statut}
                            </span>
                          );
                        }
                      } else if (type === 'fret' || type === 'fret_termine') {
                        if (key === 'nb_lots') {
                          value = item.nb_lots || 0;
                        }
                      } else if (type === 'factures') {
                        if (key === 'statut') {
                          const statutBadges = {
                            'en_attente': 'badge-warning',
                            'partiellement_paye': 'badge-info',
                            'totalement_paye': 'badge-success',
                            'soldee': 'badge-secondary',
                            'annule': 'badge-danger'
                          };
                          const statutLabels = {
                            'en_attente': 'En attente',
                            'partiellement_paye': 'Partiellement payé',
                            'totalement_paye': 'Totalement payé',
                            'soldee': 'Soldé',
                            'annule': 'Annulé'
                          };
                          value = (
                            <span className={`badge ${statutBadges[item.statut] || 'badge-secondary'}`}>
                              {statutLabels[item.statut] || item.statut_display || item.statut}
                            </span>
                          );
                        } else if (key === 'tour_associe') {
                          value = item.tour_associe ? (
                            <span className="badge badge-success">Oui</span>
                          ) : (
                            <span className="badge badge-danger">Non</span>
                          );
                        }
                        else if (key === 'parc') {
                          // Utilisez directement nom_parc depuis l'API
                          value = item.nom_parc || item.parc_id || '';
                        } else if (key === 'proprietaires') {
                          value = item.proprietaires && item.proprietaires.length > 0 ? (
                            <div>
                              {item.proprietaires.map((prop, idx) => (
                                <div key={idx} className="small">
                                  {prop.proprietaire}
                                  {prop.immatriculation && ` (${prop.immatriculation})`}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <span className="text-muted">Aucun</span>
                          );
                        } else if (key === 'nombre_lignes') {
                          value = <span className="badge badge-primary">{item.nombre_lignes}</span>;
                        }
                      }

                      return <td key={key}>{value}</td>;
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar user_id={user_id} />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-12">
            <h2 className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <FaChartBar size={25} className="mr-2" />
                Rapport et statistique
              </div>
              {/* <button
                className="btn btn-link p-0 ml-2"
                title="Aide"
                onClick={() => setShowGlossary(true)}
              >
                <FaQuestionCircle size={18} />
              </button> */}
            </h2>

            <small id='hbreadcrumb' className='d-flex justify-content-end'>
              <ol className="breadcrumb custom-breadcrumb">
                <li className="breadcrumb-item custom-breadcrumb-item">
                  <Link to={`/Menu`}>Accueil</Link>
                </li>
                <li className="breadcrumb-item custom-breadcrumb-item">
                  Rapport et statistique
                </li>
              </ol>
            </small>
          </div>
        </div>

        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="ibox ">
            <div className="ibox-content">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="nav nav-tabs" role="tablist">
                    <li>
                      <a
                        className={`nav-link ${activeTab === 'tab-1' ? 'active' : ''}`}
                        data-toggle="tab"
                        href="#tab-1"
                        onClick={() => setActiveTab('tab-1')}
                      >
                        Nbre de véhicules entrées
                      </a>
                    </li>
                    <li>
                      <a
                        className={`nav-link ${activeTab === 'tab-2' ? 'active' : ''}`}
                        data-toggle="tab"
                        href="#tab-2"
                        onClick={() => setActiveTab('tab-2')}
                      >
                        Nbre de véhicules sorties
                      </a>
                    </li>
                    <li>
                      <a
                        className={`nav-link ${activeTab === 'tab-3' ? 'active' : ''}`}
                        data-toggle="tab"
                        href="#tab-3"
                        onClick={() => setActiveTab('tab-3')}
                      >
                        Lettres de voiture
                      </a>
                    </li>
                    <li>
                      <a
                        className={`nav-link ${activeTab === 'tab-4' ? 'active' : ''}`}
                        data-toggle="tab"
                        href="#tab-4"
                        onClick={() => setActiveTab('tab-4')}
                      >
                        Frets déclarés
                      </a>
                    </li>
                    <li>
                      <a
                        className={`nav-link ${activeTab === 'tab-5' ? 'active' : ''}`}
                        data-toggle="tab"
                        href="#tab-5"
                        onClick={() => setActiveTab('tab-5')}
                      >
                        Frets chargés
                      </a>
                    </li>
                    <li>
                      <a
                        className={`nav-link ${activeTab === 'tab-6' ? 'active' : ''}`}
                        data-toggle="tab"
                        href="#tab-6"
                        onClick={() => setActiveTab('tab-6')}
                      >
                        Organisation professionnelle
                      </a>
                    </li>
                    <li>
                      <a
                        className={`nav-link ${activeTab === 'tab-7' ? 'active' : ''}`}
                        data-toggle="tab"
                        href="#tab-7"
                        onClick={() => setActiveTab('tab-7')}
                      >
                        Factures transport
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content">
                    {/* Contenu commun à tous les onglets */}
                    <div role="tabpanel" className={`tab-pane ${activeTab === activeTab ? 'active' : ''}`} id={activeTab}>
                      <div className="panel-body">
                        {stats.loading ? (
                          <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">Chargement...</span>
                            </div>
                            <p>Chargement des statistiques...</p>
                          </div>
                        ) : stats.error ? (
                          <div className="alert alert-danger">{stats.error}</div>
                        ) : (
                          <>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="w-100 d-flex gap-2 justify-content-between align-items-center mb-3">
                                  <div className="d-flex gap-2 justify-content-between align-items-center">
                                    {/* Widget compteur */}
                                    <div className="d-flex align-items-center bg-secondary text-white rounded p-2 shadow-sm mr-2">
                                      <span className="me-2">Total : </span>
                                      <h4 className="mb-0 font-bold ml-2">
                                        {getCurrentData().completeData?.length || 0}
                                      </h4>
                                    </div>

                                    <ColumnSelector
                                      type={getCurrentData().type}
                                      visibleColumns={visibleColumns}
                                      setVisibleColumns={setVisibleColumns}
                                      columnLabels={getCurrentData().columnLabels}
                                    />

                                    <Button
                                      variant="primary"
                                      onClick={handleShowRechercheModal}
                                      className="ml-3 d-flex align-items-center"
                                    >
                                      <FaSearch className="mr-2" /> Recherche avancée
                                    </Button>

                                    <Button
                                      variant="success"
                                      onClick={telechargerRapport}
                                      disabled={isloadingTelechargement}
                                      className="ml-3 d-flex align-items-center"
                                    >
                                      <FaDownload className="mr-2" /> Télécharger rapport
                                      {isloadingTelechargement && 'Chargement...'}
                                    </Button>
                                  </div>

                                  <Form.Control
                                    type="text"
                                    placeholder="Rechercher..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ width: '300px' }}
                                    className="mr-2"
                                  />
                                </div>

                                {/* Filtres appliqués */}
                                {/* {appliedFilters.length > 0 && (
                                  <AppliedFiltersDisplay
                                    filters={appliedFilters}
                                    onRemoveFilter={removeFilter}
                                  />
                                )} */}

                                {/* Statistiques agrégées */}
                                {/* {getCurrentData().aggregatedData &&
                                  Object.keys(getCurrentData().aggregatedData).length > 0 &&
                                  renderAggregatedStats(getCurrentData().type)} */}

                                {/* Tableau de données */}
                                <GenericTable
                                  type={getCurrentData().type}
                                  data={getCurrentData().completeData}
                                  columnLabels={getCurrentData().columnLabels}
                                  visibleColumns={getCurrentData().visibleColumns}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Modal de recherche avancée */}
          <Modal show={showRechercheModal} onHide={handleCloseRechercheModal} size="lg">
            <Modal.Header>
              <Modal.Title>Recherche avancée</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Row>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label><strong>Type de statistique</strong></Form.Label>
                      <Form.Control
                        type="text"
                        value={
                          activeTab === "tab-1" ? "Véhicules entrés" :
                            activeTab === "tab-2" ? "Véhicules sortis" :
                              activeTab === "tab-3" ? "Lettres disponibles" :
                                activeTab === "tab-4" ? "Fret déclaré" :
                                  activeTab === "tab-5" ? "Fret terminé" :
                                    activeTab === "tab-6" ? "Organisation professionnelle" :
                                      activeTab === "tab-7" ? "Factures transport" : ""
                        }
                        readOnly
                        disabled
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #ced4da",
                          borderRadius: "6px",
                          fontWeight: "600"
                        }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label><strong>Période</strong></Form.Label>
                      <Form.Control
                        as="select"
                        name="periode"
                        value={filters.periode}
                        onChange={handleFilterChange}
                      >
                        <option value="Tout">Tout</option>
                        <option value="jour">Jour</option>
                        <option value="semaine">Semaine</option>
                        <option value="mois">Mois</option>
                        <option value="trimestre">Trimestre</option>
                        <option value="annee">Année</option>
                        <option value="custom">Personnalisée</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  {filters.periode === 'custom' && (
                    <>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label><strong>Date début</strong></Form.Label>
                          <Form.Control
                            type="date"
                            name="date_debut"
                            value={filters.date_debut}
                            onChange={handleDateChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label><strong>Date fin</strong></Form.Label>
                          <Form.Control
                            type="date"
                            name="date_fin"
                            value={filters.date_fin}
                            onChange={handleDateChange}
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}

                  {/* Filtres spécifiques aux véhicules (entrées, sorties, lettres) */}
                  {(filters.type_stat === 'entrees' || filters.type_stat === 'sorties' || filters.type_stat === 'lettre_dispo') && (
                    <>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label><strong>Type de parc</strong></Form.Label>
                          <Form.Control
                            as="select"
                            name="type_parc"
                            value={filters.type_parc}
                            onChange={handleFilterChange}
                          >
                            <option value="">Tout</option>
                            <option value="national">National</option>
                            <option value="international">International</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label><strong>Parc</strong></Form.Label>
                          <Select
                            options={parcOptions}
                            value={parcOptions.filter(option =>
                              filters.parc_id?.includes(option.value)
                            )}
                            onChange={handleMultiSelectChange('parc_id')}
                            isMulti
                            placeholder="Tous les Parcs"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label><strong>Droit de tour</strong></Form.Label>
                          <Form.Control
                            as="select"
                            name="droit_tour"
                            value={filters.droit_tour}
                            onChange={handleFilterChange}
                          >
                            <option value="">Tout</option>
                            <option value="Non">Non</option>
                            <option value="Oui">Oui</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label><strong>Type de véhicule</strong></Form.Label>
                          <Select
                            options={typeVehiculeOptions}
                            value={typeVehiculeOptions.filter(option =>
                              filters.type_vehicule_id?.includes(option.value)
                            )}
                            onChange={handleMultiSelectChange('type_vehicule_id')}
                            isMulti
                            placeholder="Tous les types"
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}

                  {/* Filtres spécifiques au fret */}
                  {(filters.type_stat === 'fret' || filters.type_stat === 'fret_termine') && (
                    <>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label><strong>Catégorie</strong></Form.Label>
                          <Select
                            options={categorieOptions}
                            value={categorieOptions.filter(option =>
                              filters.categorie_id?.includes(option.value)
                            )}
                            onChange={handleMultiSelectChange('categorie_id')}
                            isMulti
                            placeholder="Toutes les catégories"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label><strong>Parc</strong></Form.Label>
                          <Select
                            options={parcOptions}
                            value={parcOptions.filter(option =>
                              filters.parc_id?.includes(option.value)
                            )}
                            onChange={handleMultiSelectChange('parc_id')}
                            isMulti
                            placeholder="Tous les Parcs"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group>
                          <Form.Label><strong>Type de fret</strong></Form.Label>
                          <Select
                            options={typeFretOptions}
                            value={typeFretOptions.filter(option =>
                              filters.type_fret_refs?.includes(option.value)
                            )}
                            onChange={handleMultiSelectChange('type_fret_refs')}
                            isMulti
                            placeholder="Tous les types"
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}

                  {/* Filtres spécifiques aux organisations */}
                  {filters.type_stat === 'organisation' && (
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label><strong>Organisation professionnelle</strong></Form.Label>
                        <Select
                          options={organisationOptions}
                          value={organisationOptions.filter(option =>
                            filters.organisation_ids?.includes(option.value)
                          )}
                          onChange={handleMultiSelectChange('organisation_ids')}
                          isMulti
                          placeholder="Toutes les organisations"
                        />
                      </Form.Group>
                    </Col>
                  )}

                  {/* Filtres spécifiques aux factures */}
                  {filters.type_stat === 'factures' && (
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label><strong>Parc</strong></Form.Label>
                        <Select
                          options={parcOptions}
                          value={parcOptions.filter(option =>
                            filters.parc_id?.includes(option.value)
                          )}
                          onChange={handleMultiSelectChange('parc_id')}
                          isMulti
                          placeholder="Tous les Parcs"
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseRechercheModal}>
                Annuler
              </Button>
              <Button
                variant="primary"
                onClick={fetchStats}
                disabled={stats.loading}
                className="d-flex align-items-center"
              >
                {stats.loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="mr-2" />
                    Chargement...
                  </>
                ) : 'Rechercher'}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        <div className="footer text-center">
          <div>
            <strong><a href="https://www.adnservicespro.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>ADN Services</a></strong> &copy; 2025. Tous droits réservés | Réalisé par <a href="https://inovact.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#3088C0" }}>INOVACT SARL</a>
          </div>
        </div>
      </div>
      <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
    </div>
  );
};

export default Rapport_et_statistique;